module.exports = __webpack_public_path__ + "static/img/dice_6.97487d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lottery/dice/dice_6.png
// module id = 3QEU
// module chunks = 23